export enum IntegrationType {
  InteractionWidgetType = 'embedded-client-app-interaction-widget',
  OrgPairingIntegrationType = 'genesys-dx-org-user-pairing'
}
